import React, { useState, useEffect, useMemo } from "react";
import { useParams, useHistory, withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import moment from "moment";

import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";

import useAgora from "./hooks/useVideoChat";

import Record from "../img/videochat/recording.svg";
import RecordStop from "../img/videochat/stop.gif";
import RecordAni from "../img/videochat/recording-icon.gif";

import DefaultAvatar from "./components/DefaultAvatar";
import MediaPlayer from "./components/MediaPlayer";
import ScreenSharePlayer from "./components/ScreenSharePlayer";
import Chat from "./chat";

import { oldgenericApi } from "../common/apiconfig";

import "../videochat/styles.scss";
import "./styles.scss";

let options = {
  uid: "",
  key: process.env.REACT_APP_AGORA_KEY,
  secret: process.env.REACT_APP_AGORA_SECRET,
};

function VideoChat(props) {
  const reduxdispatch = useDispatch();

  const { channel } = useParams();
  const history = useHistory();

  const [progress, setProgress] = useState(false);
  const [show, setShow] = useState(false);
  const [videoDimensions, setVideoDimensions] = useState({
    height: "200px",
    width: "180px",
    v_panel_width: "",
    v_panel_height: "65vh",
  });
  const [record_uid, setrecord_uid] = useState("");
  const [recording, setRecording] = useState(false);
  const [recordedData, setRecordedData] = useState([]);
  const [startData, setStartData] = useState("");

  let auth = options.key + ":" + options.secret;
  let encodedString = btoa(auth);
  let date = moment(new Date()).format("YYYY-MM-DD");

  useEffect(() => {
    props.UpdateFormField({ name: "hidestudytab", value: false });
    setrecord_uid(Math.floor(100000 + Math.random() * 900000).toString());
    return () => {
      props.UpdateFormField({ name: "hidestudytab", value: true });
    };
  }, []);

  const {
    client,
    localAudioTrack,
    localVideoTrack,
    toggleVideo,
    remoteUsers,
    credentials,
    joinState,
    setIsMinimized,
    leave,
    screenshare,
    isAudioMuted,
    setIsAudioMuted,
    isVideoMuted,
    error,
    isScreenSharing,
    screenTrack,
  } = useAgora(channel);

  const getDimension = () => {
    let video_panel = document.querySelector("#video-panel");
    let v_width = video_panel.clientWidth - 38;
    setVideoDimensions((prev) => ({ ...prev, v_panel_width: v_width }));
  };

  const toggleAudio = () => {
    if (!localAudioTrack) {
      console.warn("No audio track available");
      return;
    }
    const muted = !isAudioMuted;
    localAudioTrack.setMuted(muted);
    setIsAudioMuted(muted);
  };

  const handleScreenShare = async () => {
    try {
      await screenshare();
    } catch (err) {
      console.error("Screen share failed:", err);
    }
  };

  const record = async (event) => {
    setRecording(true);
    reduxdispatch({ type: "videoRecReq", value: true });
    let url = `${process.env.REACT_APP_AGORAURL}/v1/apps/${credentials.appId}/cloud_recording/acquire`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + encodedString,
      },
      body: JSON.stringify({
        cname: channel,
        uid: record_uid,
        clientRequest: {},
      }),
    })
      .then((res) => {
        if (res.status !== 200 && res.status !== 201) {
          throw new Error("Failed!");
        }
        return res.json();
      })
      .then((responseData) => {
        console.log(responseData, "Res");
        if (responseData.resourceId) {
          // let startUrl = `${process.env.REACT_APP_AGORAURL}/v1/apps/${credentials.appId}/cloud_recording/resourceid/${responseData.resourceId}/mode/mix/start`;
        let startUrl= `${process.env.REACT_APP_BASEURL}agora`
          fetch(startUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              // Authorization: "Basic " + encodedString,
            },
            body: JSON.stringify({
              cname: channel,
              resource_id: responseData.resourceId,
              env:process.env.REACT_APP_ENVTYPE,
              uid: record_uid,
              clientRequest: {
                token: credentials.token,
                recordingConfig: {
                  maxIdleTime: 300,
                  transcodingConfig: {
                    width: 640,
                    height: 360,
                    fps: 30,
                    bitrate: 600,
                    mixedVideoLayout: 1,
                  },
                },
                recordingFileConfig: {
                  avFileType: ["hls", "mp4"],
                },
                storageConfig: {
                  vendor: 1,
                  region: 3,
                  bucket:
                    "hekma-patient-videos/" +
                    localStorage.getItem("loggedInUser") +
                    "/" +
                    date +
                    "/",
                  "accessKey": process.env.REACT_APP_AGORA_CALLSTORAGE_ACCESSKEY,
                  "secretKey": process.env.REACT_APP_AGORA_CALLSTORAGE_SECRETKEY,
                },
              },
            }),
          })
            .then((res) => {
              if (res.status !== 200 && res.status !== 201) {
                throw new Error("Failed!");
              }
              return res.json();
            })
            .then((data) => {
              console.log(data, "startdata");
              setShow(true);
              setStartData(data);
            });
        }
      });
  };
  const recordstop = () => {
    console.log(startData, "Data");
    setShow(false);
    setProgress(true);
    let queryurl = `${process.env.REACT_APP_AGORAURL}/v1/apps/${credentials.appId}/cloud_recording/resourceid/${startData.resourceId}/sid/${startData.sid}/mode/mix/query`;
    fetch(queryurl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + encodedString,
      },
    })
      .then((res) => {
        if (res.status !== 200 && res.status !== 201) {
          throw new Error("Failed!");
        }
        return res.json();
      })
      .then((data) => {
        console.log(data, "query");
      });
    let stopurl = `${process.env.REACT_APP_AGORAURL}/v1/apps/${credentials.appId}/cloud_recording/resourceid/${startData.resourceId}/sid/${startData.sid}/mode/mix/stop`;

    fetch(stopurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        Authorization: "Basic " + encodedString,
      },
      body: JSON.stringify({
        cname: channel,
        uid: record_uid,
        clientRequest: {},
      }),
    })
      .then((res) => {
        if (res.status !== 200 && res.status !== 201) {
          throw new Error("Failed!");
        }
        return res.json();
      })
      .then((data) => {
        console.log(data, "stopdata");
        setRecording(false);
        // setStartData(data)
        if (data.serverResponse.uploadingStatus === "uploaded") {
          setRecordedData(data.serverResponse.fileList);
          setProgress(false);
        }
      });
  };
  const callCtmsStorageApi = async (info, chat) => {
    console.log(info, chat, "--------");
    var videofile = "";
    if (info?.length > 0) {
      var path = localStorage.getItem("loggedInUser") + "/" + date;
      videofile = `{buArea: "videocall",type:"Video", detail1: "${path}",detail2:"${info[0].fileName}"}`;
    }
    let requestBody = `
      mutation {
        putArtifactWithSupport(
          id: "${props.formValues.appointmentData?.appointmentId}",
          name: "${channel}", 
          summary:${JSON.stringify(JSON.stringify(chat))},
          type:"${date}",
          category:"",
          language:"",
          version:"",
          supportDetails:[${[videofile]}]
             ) {
            code
            type
            message
            attributes
        }
      }
    `;
    setProgress(true);
    requestBody = JSON.stringify({ query: requestBody });
    let res = await oldgenericApi("putArtifactWithSupport", requestBody);
    if (!res) {
    } else {
      if (res.data.putArtifactWithSupport.code == "200") {
        console.log("stored in ctms");
        setProgress(false);
        leave();
        props.history.goBack();
      }
    }
  };

  const handleLeaveCall = () => {
    leave();
    history.goBack();
    localStorage.removeItem("channel_id");
    callCtmsStorageApi(recordedData, props.formValues.allchat);
  };

  useEffect(() => {
    getDimension();
    setIsMinimized(false);
  }, []);

  useEffect(() => {
    if (channel) {
      localStorage.setItem("channel_id", JSON.stringify(channel));
    }
  }, [channel]);

  useEffect(() => {
    const videoPanel = document.getElementById("video-panel");
    if (videoPanel) {
      setVideoDimensions((prev) => ({
        ...prev,
        v_panel_width: videoPanel.clientWidth - 38,
      }));
    }
  }, []);

  const MemorizedVideoPlayer = useMemo(() => {
    return function VideoPlayer() {
      return localVideoTrack && localVideoTrack?.enabled ? (
        <MediaPlayer
          videoTrack={localVideoTrack}
          audioTrack={undefined}
          width={
            remoteUsers.length == 1
              ? "140px"
              : videoDimensions.v_panel_width + "px"
          }
          height={
            remoteUsers.length == 1 ? "140px" : videoDimensions.v_panel_height
          }
          local={true}
          id="local-2"
        />
      ) : (
        <DefaultAvatar size="150px" />
      );
    };
  }, [localVideoTrack, remoteUsers, videoDimensions, isVideoMuted]);

  if (error) {
    return (
      <div className="video-chat-error">
        <h2>Call Error</h2>
        <p>{error}</p>
        <button onClick={handleLeaveCall}>Return to Calls</button>
      </div>
    );
  }

  return (
    <div className="call mt-2 pb-3 mb-3" style={{ background: "#f5f5f5" }}>
      {progress && (
        <div className="fullScreen">
          <CircularProgress
            disableShrink
            className="progressCircle"
            value={90}
            size={100}
            thickness={1.5}
          />
        </div>
      )}
      <div className="video-chat-container video-container" id="video-panel">
        {!joinState && (
          <div className="call-status">
            <p>Connecting to the call...</p>
          </div>
        )}
        {/* Screen Sharing Video */}
        {isScreenSharing && screenTrack && (
          <div className="screen-share-container">
            <ScreenSharePlayer screenTrack={screenTrack} />
          </div>
        )}
        <div
          className="video video-container"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <div className="record-nav">
            {!show ? (
              <Tooltip title="Record" arrow>
                <span className="fl cr" onClick={() => record()}>
                  <img src={Record} alt="Record" height="23px" />
                </span>
              </Tooltip>
            ) : (
              <>
                <span>
                  <img src={RecordAni} alt="Recording Started" /> recording ...
                </span>

                <Tooltip title="Stop Recording" arrow>
                  <span className="cr" onClick={() => recordstop()}>
                    <img src={RecordStop} alt="stop" height="23px" />
                  </span>
                </Tooltip>
              </>
            )}
          </div>
          {remoteUsers.length > 1 ? (
            <div className="greater-people-wrapper">
              <div className="local-player-wrapper">
                <div className="local-player-text">
                  {joinState && localVideoTrack
                    ? client?._joinInfo?.optionalInfo + "(You)"
                    : ""}
                </div>
                {localVideoTrack && !isVideoMuted ? (
                  <div
                    style={{
                      width: videoDimensions.v_panel_width + "px",
                      height: videoDimensions.v_panel_height,
                    }}
                  >
                    <MediaPlayer
                      videoTrack={localVideoTrack}
                      audioTrack={undefined}
                      width={videoDimensions.v_panel_width + "px"}
                      height={videoDimensions.v_panel_height}
                      local={true}
                      id="local"
                    />
                  </div>
                ) : (
                  <DefaultAvatar
                    size={videoDimensions.v_panel_width + "px"}
                    height={videoDimensions.v_panel_height}
                  />
                )}
              </div>
              <section className="remote-people">
              {remoteUsers.map((user) => {
                return (
                  <div className="remote-player-wrapper-1" key={user.uid}>
                    {!!(!!user["_video_muted_"] && !!user.audioTrack) ? (
                      <>
                        <div style={{ display: "none" }}>
                          <MediaPlayer
                            videoTrack={user.videoTrack}
                            audioTrack={user.audioTrack}
                            width={videoDimensions.v_panel_width + "px"}
                            height={videoDimensions.v_panel_height}
                            id="remote"
                          />
                        </div>
                        <div
                          style={{
                            width: videoDimensions.width,
                            height: videoDimensions.height,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <DefaultAvatar size={videoDimensions.width} />
                        </div>
                      </>
                    ) : !!(user.videoTrack && !user["_video_muted_"]) ||
                      !!user.audioTrack ? (
                      <MediaPlayer
                        videoTrack={user.videoTrack}
                        audioTrack={user.audioTrack}
                        width={"200px"}
                        height={"200px"}
                        id="remote"
                      />
                    ) : (
                      <DefaultAvatar size={videoDimensions.width} />
                    )}
                  </div>
                );
              })}
              </section>
            </div>
          ) : (
            <>
              <div
                className={`local-player-wrapper-1 ${remoteUsers.length == 1 ? "localcss" : ""
                  }`}
              >
                <MemorizedVideoPlayer />
              </div>
              {remoteUsers.map((user) => {
                return (
                  <div className="remote-player-wrapper" key={user.uid}>
                    {!!(!!user["_video_muted_"] && !!user.audioTrack) ? (
                      <>
                        <div style={{ display: "none" }}>
                          <MediaPlayer
                            videoTrack={user.videoTrack}
                            audioTrack={user.audioTrack}
                            width={videoDimensions.v_panel_width + "px"}
                            height={videoDimensions.v_panel_height}
                            id="remote"
                          />
                        </div>
                        <div
                          style={{
                            width: videoDimensions.width,
                            height: videoDimensions.height,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <DefaultAvatar size={videoDimensions.width} />
                        </div>
                      </>
                    ) : !!(user.videoTrack && !user["_video_muted_"]) ||
                      !!user.audioTrack ? (
                      <MediaPlayer
                        videoTrack={user.videoTrack}
                        audioTrack={user.audioTrack}
                        width={videoDimensions.v_panel_width + "px"}
                        height={videoDimensions.v_panel_height}
                        id="remote"
                      />
                    ) : (
                      <DefaultAvatar size={videoDimensions.width} />
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>

        <div className="video-controls">
          <button
            onClick={toggleAudio}
            className={`audio-toggle ${isAudioMuted ? "muted" : "active"}`}
          >
            <i
              className={`fas ${isAudioMuted ? "fa-microphone-slash" : "fa-microphone"
                }`}
            ></i>
            {isAudioMuted ? "Unmute" : "Mute"}
          </button>
          <button
            onClick={toggleVideo}
            className={`video-toggle ${isVideoMuted ? "muted" : "active"}`}
          >
            <i
              className={`fas ${isVideoMuted ? "fa-video-slash" : "fa-video"}`}
            ></i>
            {isVideoMuted ? "Show Video" : "Hide Video"}
          </button>
          {/* Screen Share */}
          <button
            onClick={handleScreenShare}
            className={`screen-share ${isScreenSharing ? "active" : "muted"}`}
          >
            <i className={`fas fa-desktop`}></i>
            {isScreenSharing ? "Stop Sharing" : "Share Screen"}
          </button>

          {/* Leave Call */}
          <button onClick={handleLeaveCall} className="leave-call">
            <i className="fas fa-phone-slash"></i>
            Leave Call
          </button>
        </div>
      </div>

      {joinState && client && (
        <div
          className="chat-container col-md-4 col-xs-5"
          id="chat-panel"
          style={{ paddingLeft: "0px" }}
        >
          <Chat
            clientId={client.uid}
            channel={{
              name: channel,
              clientname: localStorage.getItem("loggedInUser"),
            }}
          />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch({
        type: "UpdateFormField",
        value: obj.value,
        name: obj.name,
      });
    },
    videoRecReq: (value) => {
      return dispatch({
        type: "videoRecReq",
        value: value,
      });
    },
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VideoChat)
);
